import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { salesByRegion: { getSalesByRegion, getTopSalesLocations, getTopSalesCategory } } = apiUrls;

export const SALES_BY_REGION_HEATMAP_SUCCESS = 'SALES_BY_REGION_HEATMAP_SUCCESS';
export const SALES_BY_REGION_HEATMAP_LOADING = 'SALES_BY_REGION_HEATMAP_LOADING';
export const TOP_LOCATION_SALES_SUCCESS = 'TOP_LOCATION_SALES_SUCCESS';
export const TOP_LOCATION_SALES_LOADING = 'TOP_LOCATION_SALES_LOADING';
export const TOP_CATEGORY_SALES_SUCCESS = 'TOP_CATEGORY_SALES_SUCCESS';
export const TOP_PRODUCT_SALES_LOADING = 'TOP_PRODUCT_SALES_LOADING';

export const getSalesByRegionData = ({ from: fromYear, to: toYear,
    fromMonth, toMonth, isCityWise, region, subRegion }) => async (dispatch) => {
        try {
            const requestData = {
                ...getSalesByRegion,
                data: {
                    toYear,
                    fromYear,
                    fromMonth,
                    toMonth,
                    isCityWise,
                    region: region || "", subRegion: subRegion || ""
                }
            };
            const data = await REQUEST(requestData);

            let dataObject = data?.modal
                ?.data;
            dataObject = dataObject?.map(item => ({
                ...item, id: item?.countryCode, value: Number(item.amount)
            }))

            dispatch({
                type: SALES_BY_REGION_HEATMAP_SUCCESS,
                data: { ...data, modal: { ...data.modal, data: dataObject } },
            })
        } catch (e) {

            dispatch({
                type: SALES_BY_REGION_HEATMAP_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }

export const getTopSalesLocationsData = ({ from: fromYear, to: toYear,
    fromMonth, toMonth, isCityWise, region, subRegion,prodCategory }) => async (dispatch) => {
        try {
            const requestData = {
                ...getTopSalesLocations,
                data: {
                    toYear,
                    fromYear,
                    fromMonth,
                    toMonth,
                    isCityWise,
                    region: region || "", 
                    subRegion: subRegion || "",
                    prodCategory: prodCategory || ""
                }
            };
            const data = await REQUEST(requestData);

            dispatch({
                type: TOP_LOCATION_SALES_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: TOP_LOCATION_SALES_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }


export const getTopSalesProductData = ({ from: fromYear, to: toYear,
    fromMonth, toMonth, isCityWise, region, subRegion,prodCategory }) => async (dispatch) => {
        try {
            const requestData = {
                ...getTopSalesCategory,
                data: {
                    toYear,
                    fromYear,
                    fromMonth,
                    toMonth,
                    isCityWise,
                    region: region || "", 
                    subRegion: subRegion || "",
                    prodCategory: prodCategory || ""
                }
            };
            const data = await REQUEST(requestData);

            dispatch({
                type: TOP_CATEGORY_SALES_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: TOP_CATEGORY_SALES_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }


export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: SALES_BY_REGION_HEATMAP_LOADING,
        isLoading
    })
}

export const handleTopProductLoader = isTopProductLoading => (dispatch) => {
    dispatch({
        type: TOP_PRODUCT_SALES_LOADING,
        isTopProductLoading
    })
}

export const handleTopLocationLoader = isTopLocationsLoading => (dispatch) => {
    dispatch({
        type: TOP_LOCATION_SALES_LOADING,
        isTopLocationsLoading
    })
}